export interface Resource {
  id: string;
  name: string;
  city: string;
  description: string;
  phone?: string;
  website?: string;
}

export interface ResourceSection {
  id: string;
  title: string;
  icon: string;
  color: string;
  bgColor: string;
  borderColor: string;
  iconBg: string;
  buttonBorder: string;
  buttonText: string;
  resources: Resource[];
}

export const resourceSections: ResourceSection[] = [
  {
    id: 'food',
    title: 'Food Support',
    icon: 'ri-restaurant-2-line',
    color: 'text-amber-700',
    bgColor: 'bg-amber-50',
    borderColor: 'border-amber-200',
    iconBg: 'bg-amber-100',
    buttonBorder: 'border-amber-300',
    buttonText: 'text-amber-700',
    resources: [
      {
        id: 'f1',
        name: 'North Gwinnett Co-Op',
        city: 'Buford, GA',
        description: 'Food pantry and financial assistance for families in North Gwinnett County.',
        website: 'https://www.northgwinnettcoop.org',
      },
      {
        id: 'f2',
        name: 'Lawrenceville Cooperative Ministry',
        city: 'Lawrenceville, GA',
        description: 'Emergency food pantry and financial assistance for Gwinnett County residents.',
        website: 'https://www.lawrencevilleco-op.org',
      },
      {
        id: 'f3',
        name: 'Atlanta Community Food Bank',
        city: 'Gwinnett County & Metro Atlanta',
        description: 'Connects families to local food pantries and meal programs across Gwinnett and surrounding areas.',
        website: 'https://www.acfb.org',
      },
      {
        id: 'f4',
        name: 'MUST Ministries',
        city: 'Marietta, GA (serves Gwinnett area)',
        description: 'Food pantry, hot meals, and emergency assistance for families and individuals in need.',
        website: 'https://www.mustministries.org',
      },
      {
        id: 'f5',
        name: 'Salvation Army — Gwinnett County',
        city: 'Lawrenceville, GA',
        description: 'Food assistance, emergency rent and utility help, and family services.',
        website: 'https://southernusa.salvationarmy.org/gwinnett',
      },
    ],
  },
  {
    id: 'family',
    title: 'Family & Child Support',
    icon: 'ri-parent-line',
    color: 'text-teal-700',
    bgColor: 'bg-teal-50',
    borderColor: 'border-teal-200',
    iconBg: 'bg-teal-100',
    buttonBorder: 'border-teal-300',
    buttonText: 'text-teal-700',
    resources: [
      {
        id: 'fam1',
        name: '211 — United Way Help Line',
        city: 'Gwinnett County & Statewide',
        description: 'Dial 211 to get connected to childcare, food, housing, and family services in your area — fast.',
        phone: '211',
        website: 'https://www.unitedwayatlanta.org/211',
      },
      {
        id: 'fam2',
        name: 'Gwinnett County DFCS',
        city: 'Lawrenceville, GA',
        description: 'State agency offering SNAP, childcare assistance, Medicaid, and family support services.',
        website: 'https://dfcs.georgia.gov/gwinnett-county',
      },
      {
        id: 'fam3',
        name: 'Childcare and Parent Services (CAPS)',
        city: 'Gwinnett County',
        description: 'Subsidized childcare for income-eligible families so parents can work or attend school.',
        website: 'https://caps.decal.ga.gov',
      },
      {
        id: 'fam4',
        name: 'Gwinnett County Juvenile Court CASA',
        city: 'Lawrenceville, GA',
        description: 'Court Appointed Special Advocates supporting children in the foster care system across Gwinnett.',
        website: 'https://www.gwinnettcasa.org',
      },
    ],
  },
  {
    id: 'health',
    title: 'Health & Wellness',
    icon: 'ri-heart-pulse-line',
    color: 'text-rose-700',
    bgColor: 'bg-rose-50',
    borderColor: 'border-rose-200',
    iconBg: 'bg-rose-100',
    buttonBorder: 'border-rose-300',
    buttonText: 'text-rose-700',
    resources: [
      {
        id: 'h1',
        name: 'Gwinnett County Board of Health',
        city: 'Lawrenceville, GA',
        description: 'Public health clinics offering immunizations, family planning, WIC, and general health services.',
        website: 'https://www.gwinnettcounty.com/departments/health',
      },
      {
        id: 'h2',
        name: 'WIC — Georgia Program',
        city: 'Gwinnett County',
        description: 'Nutrition support, healthy food benefits, and breastfeeding resources for pregnant women and young children.',
        website: 'https://dph.georgia.gov/wic',
      },
      {
        id: 'h3',
        name: 'Community Health Center of East Georgia',
        city: 'Gwinnett & Surrounding Counties',
        description: 'Affordable primary care, dental, and behavioral health services on a sliding-fee scale.',
        website: 'https://chcofeastgeorgia.org',
      },
      {
        id: 'h4',
        name: 'Northside Hospital Gwinnett',
        city: 'Lawrenceville, GA',
        description: 'Full-service hospital with women\'s health, maternity, pediatrics, and family care services.',
        website: 'https://www.northside.com/gwinnett',
      },
    ],
  },
  {
    id: 'mental-health',
    title: 'Mental Health Support',
    icon: 'ri-mental-health-line',
    color: 'text-purple-700',
    bgColor: 'bg-purple-50',
    borderColor: 'border-purple-200',
    iconBg: 'bg-purple-100',
    buttonBorder: 'border-purple-300',
    buttonText: 'text-purple-700',
    resources: [
      {
        id: 'mh1',
        name: 'View Point Health',
        city: 'Gwinnett County, GA',
        description: 'Mental health services, crisis support, and family counseling for all Gwinnett County residents.',
        website: 'https://www.myviewpointhealth.org',
      },
      {
        id: 'mh2',
        name: 'NAMI Georgia',
        city: 'Statewide (Gwinnett chapter)',
        description: 'Free mental health education, support groups, and resources for individuals and families.',
        website: 'https://namigeorgia.org',
      },
      {
        id: 'mh3',
        name: 'Crisis Text Line',
        city: 'Available Nationwide',
        description: 'Text HOME to 741741 for free, confidential crisis support — available 24/7.',
        phone: '741741',
        website: 'https://www.crisistextline.org',
      },
      {
        id: 'mh4',
        name: 'Postpartum Support International — Georgia',
        city: 'Georgia Chapter',
        description: 'Support and resources for moms experiencing postpartum depression, anxiety, and other perinatal mood disorders.',
        website: 'https://www.postpartum.net',
      },
    ],
  },
  {
    id: 'housing',
    title: 'Housing & Financial Help',
    icon: 'ri-home-heart-line',
    color: 'text-indigo-700',
    bgColor: 'bg-indigo-50',
    borderColor: 'border-indigo-200',
    iconBg: 'bg-indigo-100',
    buttonBorder: 'border-indigo-300',
    buttonText: 'text-indigo-700',
    resources: [
      {
        id: 'hou1',
        name: 'Gwinnett County Community Services',
        city: 'Lawrenceville, GA',
        description: 'Emergency rental and utility assistance, weatherization, and support programs for low-income families.',
        website: 'https://www.gwinnettcounty.com/departments/communityservices',
      },
      {
        id: 'hou2',
        name: 'Gwinnett Housing Corporation',
        city: 'Lawrenceville, GA',
        description: 'Affordable housing options and homebuyer assistance for families in Gwinnett County.',
        website: 'https://www.gwinnetthousingcorp.org',
      },
      {
        id: 'hou3',
        name: 'Action Ministries',
        city: 'Gwinnett & Metro Atlanta',
        description: 'Rent and utility assistance, housing stability, and transitional programs for families in need.',
        website: 'https://www.actionministries.net',
      },
      {
        id: 'hou4',
        name: 'Georgia Rental Assistance Program',
        city: 'Statewide (includes Gwinnett)',
        description: 'State-funded emergency rental assistance for households impacted by financial hardship.',
        website: 'https://ga.gov/rental-assistance',
      },
    ],
  },
  {
    id: 'community',
    title: 'Community & Education Resources',
    icon: 'ri-book-open-line',
    color: 'text-emerald-700',
    bgColor: 'bg-emerald-50',
    borderColor: 'border-emerald-200',
    iconBg: 'bg-emerald-100',
    buttonBorder: 'border-emerald-300',
    buttonText: 'text-emerald-700',
    resources: [
      {
        id: 'ce1',
        name: 'Gwinnett County Public Library',
        city: 'Multiple locations, Gwinnett County',
        description: 'Free library access, storytime for kids, computer use, job search help, and community programs.',
        website: 'https://www.gwinnettpl.org',
      },
      {
        id: 'ce2',
        name: 'Gwinnett County Public Schools',
        city: 'Gwinnett County, GA',
        description: 'Resources for enrollment, special education, Title I programs, and family engagement support.',
        website: 'https://www.gcpsk12.org',
      },
      {
        id: 'ce3',
        name: 'Gwinnett Technical College',
        city: 'Lawrenceville, GA',
        description: 'Affordable workforce training, adult education, and college programs for working parents.',
        website: 'https://www.gwinnetttech.edu',
      },
      {
        id: 'ce4',
        name: 'Gwinnett Coalition for Health & Human Services',
        city: 'Lawrenceville, GA',
        description: 'Connects residents to over 200 local nonprofits and community service organizations across Gwinnett.',
        website: 'https://www.gwinnettcoalition.org',
      },
    ],
  },
];
